import { useEffect } from 'react'
import { hubspotChatStore } from 'store/hubspotChatStore'

/**
 * While the calling component is mounted, request that the HubSpot chat widget
 * be hidden. Used by surfaces that must exclude the chatbot but are not their
 * own route (e.g. the pre-session quiz dialog).
 */
export function useSuppressHubSpotChat() {
  useEffect(() => {
    hubspotChatStore.addSuppressor()
    return () => hubspotChatStore.removeSuppressor()
  }, [])
}
